module.exports = __webpack_public_path__ + "img/logo_fluxsolar_co.1455fc0c.png";